<template>
  <el-popover
    popper-class="popover-select"
    placement="top-start"
    trigger="click"
    v-model="visible"
    :visible-arrow="false"
  >
    <div>
      <el-checkbox-group
        :value="value"
        size="mini"
        v-if="multiple"
        @input="change"
      >
        <el-checkbox v-for="opt in options" :key="opt.value" :label="opt.value">
          {{ opt.text }}
          <i
            v-if="opt.searchable"
            class="el-icon-search"
            @click.stop.prevent="search(opt.value)"
          ></i>
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <el-radio-group :value="value" size="mini" v-if="!multiple" @input="change">
      <el-radio v-for="opt in options" :key="opt.value" :label="opt.value">{{
        opt.text
      }}</el-radio>
    </el-radio-group>
    <el-link slot="reference" type="info">
      {{ text }}
      <i v-if="icon" :class="icon"></i>
    </el-link>
  </el-popover>
</template>

<script>
import find from 'lodash/find';
export default {
  props: {
    text: String,
    icon: String,
    multiple: {
      type: Boolean,
      default: () => false
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Array, String],
      default: () => []
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    change(val) {
      //console.log('va', val);
      if (!this.multiple) {
        const select = find(this.options, opt => opt.value === val);
        this.$emit('input', select.value);
        this.visible = false;
        return;
      }
      const values = val.reduce((acc, v) => {
        const select = find(this.options, opt => opt.value === v);
        if (select) {
          acc.push(select.value);
        }
        return acc;
      }, []);
      this.$emit('input', values);
    },
    search(value) {
      this.$emit('search', value);
    }
  }
};
</script>

<style lang="less" scope>
.popover-select {
  color: #fff;
  border: 0;
  z-index: 2000 !important;
  min-width: 110px;

  .el-checkbox-group {
    display: flex;
    flex-direction: column;

    .el-checkbox {
      margin: 2px 0;
      &:hover {
        color: @blue;
      }
    }
  }

  .el-radio {
    display: block;
    line-height: 20px;
    margin: 2px 0;
  }
}
</style>
